<div class="container">
    <div class="entity-toolbar">
        <div class="left-tools">
            <button class="icon-button active" [class.active]="viewMode === 'detail'" (click)="onViewChange('detail')">
                <i class="fa fa-list"></i>
            </button>
            <button class="icon-button" [class.active]="viewMode === 'card'" (click)="onViewChange('card')">
                <i class="fa fa-th-large"></i>
            </button>
        </div>
        <button class="add-trainer-button my-btn" (click)="openAddTrainer()">
            <i class="fa fa-plus"></i> Add Trainer
        </button>
    </div>

    <div class="trainer-card-list" *ngIf="viewMode === 'detail'">
        <div class="trainer-card-header">
            <span>Name</span>
            <span>Email</span>
            <span>Mobile</span>
            <span>Age</span>
            <span>Skills</span>
            <span class="grid-column">Actions</span>
        </div>

        <div class="trainer-card-row" *ngFor="let trainer of trainers">
            <span>{{ trainer.name }}</span>
            <span>{{ trainer.email }}</span>
            <span>{{ trainer.mobile }}</span>
            <span>{{ trainer.age }}</span>
            <span>{{ trainer.skills.join(', ') }}</span>
            <span class="actions">
                <button class="icon-button" (click)="editTrainer(trainer)">
                    <i class="fa fa-pen"></i>
                </button>
                <!-- <button class="icon-button">
                    <i class="fa fa-trash"></i>
                </button> -->
            </span>
        </div>
    </div>
    <div class="trainer-card-grid" *ngIf="viewMode === 'card'">

        <div class="trainer-card" *ngFor="let trainer of trainers">
            <div class="card-header">
                <div class="avatar">{{ trainer.name[0] }}</div>
                <i class="fa fa-ellipsis-v menu-icon edit-icon" (click)="toggleMenu($event, trainer)"></i>
                <div class="dropdown-menu" [ngClass]="{'show': trainer.id ===selectedTrainerId}" #menu>
                  <div class="menu-item" (click)="editTrainer(trainer)">
                    <i class="fa fa-pencil"></i> Edit
                  </div>
                  <!-- <div class="menu-item" (click)="deleteTrainer(trainer)">
                    <i class="fa fa-trash"></i> Delete
                  </div> -->
                </div>
              </div>

            <div class="card-body">
                <h3 class="trainer-name">{{ trainer.name }}</h3>

                <p class="info-line">
                    <i class="fa fa-envelope"></i> {{ trainer.email }}
                </p>
                <p class="info-line">
                    <i class="fa fa-phone"></i> {{ trainer.mobile }}
                </p>

                <hr />

                <p><strong>Age :</strong> {{ trainer.age }}</p>
                <p><strong>Skills :</strong> {{trainer.skills.join(', ') }}</p>
                <p><strong>Bio :</strong> {{ trainer.bioData }}</p>
            </div>
        </div>
    </div>

    <div class="modal" *ngIf="showModal">
        <div class="modal-content wide compact">
            <h3>Trainer Details</h3>
            <form (submit)="saveTrainer($event)" class="form-grid-two-column compact-form no-horizontal-gap">
                <div>
                    <label for="name">Name:</label>
                    <mat-form-field appearance="outline">
                        <mat-label>Name</mat-label>
                        <input matInput id="name" [(ngModel)]="newTrainer.name">
                    </mat-form-field>
                </div>

                <div>
                    <label for="email">Email:</label>
                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input matInput id="email" type="email" [(ngModel)]="newTrainer.email">
                    </mat-form-field>
                </div>

                <div>
                    <label for="mobile">Mobile:</label>
                    <mat-form-field appearance="outline">
                        <mat-label>Mobile</mat-label>
                        <input matInput id="mobile" [(ngModel)]="newTrainer.mobile">
                    </mat-form-field>
                </div>

                <div>
                    <label for="age">Age:</label>
                    <mat-form-field appearance="outline">
                        <mat-label>Age</mat-label>
                        <input matInput id="age" type="number" [(ngModel)]="newTrainer.age" min="0">
                    </mat-form-field>
                </div>

                <div>
                    <label for="skills">Skills (comma separated):</label>
                    <mat-form-field appearance="outline">
                        <mat-label>Skills (comma separated)</mat-label>
                        <input matInput id="skills" [value]="newTrainer.skills.join(', ')"
                            (input)="onSkillsChanged({value: $any($event.target).value})">
                    </mat-form-field>
                </div>

                <div>
                    <label for="bioData">Bio Data:</label>
                    <mat-form-field appearance="outline">
                        <mat-label>Bio Data</mat-label>
                        <textarea matInput id="bioData" [(ngModel)]="newTrainer.bioData" rows="4"></textarea>
                    </mat-form-field>
                </div>

                <div class="modal-actions">
                    <button class="my-btn" type="submit">Save</button>
                    <button class="my-btn" type="button" (click)="closeModal()">Cancel</button>
                </div>
            </form>
        </div>
    </div>
</div>
